export default __webpack_public_path__ + "static/media/SomeGuy_x768.8d50fcd3.png";